import { Subject } from 'rxjs';
export const dir$ = new Subject();
window.f5.onDirChange((dir, files) => dir$.next({ dir, files }));
